module.exports = {
      id: "close_small-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "svg-sprite-39ec39c5b3d32c0adb9732979a5c9627.svg#close_small",
      toString: function () {
        return this.url;
      }
    }